<template>
  <!-- <div id="scrollFooter" class="scroll-footer" style="bottom: auto;"> --><!--style="width: 221px;" -->
    <div class="bet-menu-wrap" :class="{'bet-menu-left':!sportMiniBet.toggle}" :style="{'width':sportMiniBet.toggle?'':'221px;'}">
      <div class="bottom-wrap" :class="{'bottom-confirm':betting.success||betting.betcombosuccess||betting.pending||betting.reject}">
        <div @click="clearInvalidBetCombo()" class="remove-invalid-item cursor-pointer text-center" 
          v-if="(isBetCombo && betting.betcomboerror && betting.betcomboerror.code=='N-4000-N') || (isMulp && betting.error && betting.error.code != undefined)">
          {{ betLang["BETTING.LBL_REMOVE_INVALID"] }}
          <i aria-hidden="true" role="presentation" class="bet-del q-icon icon-del c-icon"></i>
        </div>
        <template v-if="!isMulp">
          <div class="bet-message text-center" :class="{'bet-err':betting.error}" 
            v-if="!betting.success" :style="{'height':betting.error?'auto':''}">

            <template v-if="betFormOddChange">{{ betLang["BETTING.LBL_ODDS_CHANGE"] }}</template>
            <template v-if="betFormHdpChange">
              <template v-if="betFormOddChange">,</template>
              {{ betLang["BETTING.LBL_HANDICAP_CHANGE"] }}
            </template>
            <template v-if="betting.sErr">
              {{ betting.sErr.message }}<br>{{ betting.sErr.code }}
            </template>
            <template v-else-if="betting.error">
              {{ betting.error.message }}<br>{{ betting.error.code }}
            </template>
            <template v-else-if="jsError.error">{{ jsError.msg }}</template>
          </div>

          <div class="full-width" v-if="!betting.success && !betting.betcombosuccess && !betting.pending && !betting.reject">
            <div class="vrow bet-buttons">
              <div class="full-width cursor-pointer" @click="confirmBetForm()" :class="getSubmitStyle()" > 
                <template v-if="betFormOddChange || betFormHdpChange">
                  {{ betLang["BETTING.LBL_ACCEPT_CHANGE"] }}
                </template>
                <template v-else>
                  {{ betLang["BETTING.LBL_BET"] }}
                </template>
              </div>
              <div class="full-width cursor-pointer bet-delete-all" 
                v-if="!betting.success && !betting.betcombosuccess && !betting.pending && !betting.reject" @click="cancelBetForm()"> 
                {{betLang['BETTING.LBL_CANCEL']}}
              </div>
            </div>
          </div>
          <div class="full-width bet-foot-menu" v-if="!betting.success && !betting.betcombosuccess && !betting.pending && !betting.reject">
            <!-- OneWallet not allow have better odd -->
            <label class="vrow check-bet-prefer cursor-pointer" v-if="showAutoInfo() && account.oneWallet!='1'">
              <input type="checkbox" v-model="autoAccBetterOdd" />
              <div class="check-wrap relative-position" :class="{'active':autoAccBetterOdd}"></div>
              {{ betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"] }}
            </label>
            <label class="vrow check-box cursor-pointer" v-if="!isBetCombo || (isBetCombo && Object.keys(betForm).length==1)">
              <input type="checkbox" v-model="rememberStake" />
              <div class="check-wrap relative-position" :class="{'active':rememberStake}"></div>
              {{ betLang["BETTING.LBL_REMEMBER_STAKE"] }}
            </label>
          </div>
        </template>
      
        <!-- Bet Slip -->
        <template v-if="betting.success || betting.betcombosuccess || betting.pending || betting.reject">
          <div v-if="isMulp" class="bet-confirm-message text-center yb-fontsize12" :class="getBetConfirmClass()">
            <template v-if="betting.success || betting.betcombosuccess">
              {{ betLang["BETTING.LBL_BET_CONFIRM"] }}
            </template>
            <template v-else-if="betting.pending">
              {{ betLang['BETTING.LBL_PENDING_BET'] }}
            </template>
            <template v-else>
              {{ betLang["BETTING.LBL_REJECT_B"] }}
            </template>
          </div>
          <template v-if="(betFormOddChange || betFormHdpChange || allowErrBetAgain) && !isMulp">
            <div class="full-width bet-foot-complete mt10">
              <div class="full-width cursor-pointer bet-accpet" @click="confirmBetForm()">{{ betLang["BETTING.LBL_ACCEPT_CHANGE"] }}</div>
            </div>
            <div class="full-width bet-foot-save">
              <div class="full-width cursor-pointer bet-delete-all" @click="cancelBetForm()">
                  {{betLang['BETTING.LBL_CANCEL']}}
              </div>
            </div>
            <div class="full-width bet-foot-menu">
              <!-- OneWallet not allow have better odd -->
              <label class="vrow check-bet-prefer cursor-pointer" v-if="showAutoInfo() && account.oneWallet!='1'">
                <input type="checkbox" v-model="autoAccBetterOdd" />
                <div class="check-wrap relative-position" :class="{'active':autoAccBetterOdd}"></div>
                {{ betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"] }}
              </label>
              <label class="vrow check-box cursor-pointer" v-if="!isBetCombo || (isBetCombo && Object.keys(betForm).length==1)">
                <input type="checkbox" v-model="rememberStake" />
                <div class="check-wrap relative-position" :class="{'active':rememberStake}"></div>
                {{ betLang["BETTING.LBL_REMEMBER_STAKE"] }}
              </label>
            </div>
          </template>
          <template v-else>
            <div class="full-width bet-foot-complete mt10" @click="closeBetForm()">
              <div class="full-width cursor-pointer bet-confirm">{{ betLang["BETTING.LBL_CONFIRM"] }}</div>
            </div>
            <div class="full-width bet-foot-save" @click="retainSelection()">
              <div class="full-width cursor-pointer bet-save-items">{{ betLang["BETTING.LBL_RETAIN_SELECTION"] }}</div>
            </div>
          </template>
          <!-- <div class="full-width bet-foot-complete mt10" @click="closeBetForm()">
            <div class="full-width cursor-pointer bet-confirm">{{ betLang["BETTING.LBL_CONFIRM"] }}</div>
          </div>
          <div class="full-width bet-foot-save" @click="retainSelection()">
            <div class="full-width cursor-pointer bet-save-items">{{ betLang["BETTING.LBL_RETAIN_SELECTION"] }}</div>
          </div> -->
          <template v-if="promotionFlag && !isMulp && (betting.success || betting.betcombosuccess || betting.pending) && promotionShowJoinSuccess">
            <div class="promotion_joined_box">
              <div class="promotion_joined">{{langList.promotion['promotion.promotion_congrats_join']}}</div>
              <div class="promotion_joined_img"></div>
            </div>
          </template>
        </template>
        
        <!-- MULP -->
        <template v-if="isMulp && !betting.success">
          <hr aria-orientation="horizontal" class="q-separator bet-mix-separator q-separator q-separator--horizontal">
          <div class="full-width pt15">
            <div class="vrow bet-total">
              <!-- <div class="col bet-total-left">{{ betLang["BETTING.LBL_TOTAL_BET"] }} 1</div> -->
              <div class="col bet-total-left">{{ betLang["BETTING.LBL_TOTAL_BET"] }} {{ countTotalStakePayout('totalBet') }}</div>
              <!-- <div class="col-auto bet-total-right">{{ totalStake | decimal(2) }}</div> -->
              <div class="col-auto bet-total-right">{{ countTotalStakePayout('totalStake') | decimal(2) }}</div>
            </div>
            <div class="vrow bet-total">
              <div class="col bet-total-left">{{ betLang["BETTING.LBL_EST_WIN"] }}
                <!-- 预计总收益  -->
              </div>
              <!-- <div class="col-auto bet-total-right bet-gold-text">{{ possiblePayout | decimal(2) }}</div> -->
              <div class="col-auto bet-total-right bet-gold-text">{{ countTotalStakePayout('possiblePayout') | decimal(2) }}</div>
            </div>
            <hr aria-orientation="horizontal" class="q-separator bet-mix-separator q-separator q-separator--horizontal">
            <div class="bet-message text-center" :class="{'bet-err':betting.error}" 
            style="height: auto;line-height: normal;margin: 15px 0;">
            <!-- :style="{'height':betting.error?'auto':''}"> -->
              <template v-if="betting.minMax!= undefined && Object.keys(betForm).length < betting.minMax.minCombo">
                {{ minComboCaption() }}
              </template>
              <template v-else-if="betting.sErr">
                {{ betting.sErr.message }}<br>{{ betting.sErr.code }}
              </template>
              <template v-else-if="betting.error">
                {{ betting.error.message }}<br>{{ betting.error.code }}
              </template>
              <template v-else-if="jsError.error">{{ jsError.msg }}</template>
              <template v-else-if="mulpJsErr.error">{{ mulpJsErr.msg }}</template>
              <!-- 红色选项不可结合进行串关投注  -->

            </div>
            <div class="vrow bet-buttons">
              <div class="full-width">
                <div class="full-width cursor-pointer bet-submit" :class="{'bet-submit2':(betting.error || betting.minMax==undefined || Object.keys(betForm).length < betting.minMax.minCombo || disableBet)}" @click="confirmBetForm()">
                  <!-- {{ betLang["BETTING.LBL_BET"] }} -->
                  <template v-if="betFormOddChange || betFormHdpChange">
                    {{ betLang["BETTING.LBL_ACCEPT_CHANGE"] }}
                  </template>
                  <template v-else>
                    {{ betLang["BETTING.LBL_BET"] }}
                  </template>
                </div>
              </div>
              <div class="full-width">
                <div class="full-width cursor-pointer bet-delete-all" @click="cancelBetForm()"> 
                  {{ betLang["BETTING.LBL_REMOVE_ALL"] }} &nbsp; 
                  <i aria-hidden="true" role="presentation" class="bet-del q-icon icon-del c-icon"></i>
                </div>
              </div>
              <div class="full-width bet-foot-menu mulp-bet-foot-menu">
                <label class="vrow check-bet-prefer cursor-pointer" v-if="showAutoInfo()">
                  <input type="checkbox" v-model="autoAccBetterOdd" />
                  <div class="check-wrap relative-position" :class="{'active':autoAccBetterOdd}"></div>
                  {{ betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"] }}
                </label>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
import EventBus from "@/vue/events/event-bus";
import allBetMixin from "@/vue/mixins/allBet";
import sportFavourite from '@/vue/mixins/favourite'
import accounting from "accounting";
import moment from "moment";
import vueCookie from 'vue-cookie'

// import forecastCalculationMixin from '@/vue/mixins/forecastCalculation'
// import forecast from '@/vue/components/forecast'
// import VueFilterNumber from "@/vue/filters/vue-filter-number";
// import accounting from "accounting";
import { mapGetters } from "vuex";
export default {
  mixins: [allBetMixin,sportFavourite],
  computed: {
    ...mapGetters([
      "oddSelected",
      "BetTypeLang",
      "selectedBettype",
      "betForm",
      "betting",
      "requestAllow",
      "selectedSport",
      "account",
      "selectedMarket",
      'isBetSuccess',
      'isProcessBet',
      'isPlacedBet',
      'pendingFlag',
      'hdpDisp',
      'mulpSetting',
      'jsError',
      // 'forecast',
      'sportForecastToggle',
      'sportMiniBet',
      'betFormHdpChange',
      'betFormOddChange',
      'isBetCombo',
      // 'betComboErr',
      'promotionDetails',
      'promotionFlag',
      'promotionBetStatus',
      'promotionShowJoinSuccess',
      'wgHdpOddNoChgIndex',
      'allowErrBetAgain',
      'betMulpAmount',
      'disableBet',
      'selectedMulpBetBoxId',
    ]),
    selectedMarket() {
      return this.$store.getters.selectedMarket;
    },
    // betAllUp: {
    //   get() {
    //     var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x')
    //     if(this.betAmount && this.$store.getters.sportMiniBet.betAmount>0){
    //       this.totalStake = this.$store.getters.sportMiniBet.betAmount * totalBetSlip[1];
    //     }else{
    //       this.totalStake =0;
    //     }
        
    //     this.totalBet = totalBetSlip[1];
    //     return this.$store.getters.betting.selectedBetAllup;
    //   },
    //   set(value) {
    //     this.$store.commit("BETTING_ALLUP", value);
    //   },
    // },
    autoAccBetterOdd: {
      get() {
        return this.$store.getters.account.autoAccBetterOdd;
      },
      set(value) {
        var account = this.$store.getters.account;
        account.autoAccBetterOdd = value;
        this.$store.commit("ACCOUNT", account);
      },
    },
    rememberStake: {
      get() {
        // var stk=false
        // if(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting')) {
        //   var arr = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
        //   stk = arr.rmbStk
          // this.rememberStakeVal = stk
        // }

        return this.$store.getters.account.rememberStake;
      },
      set(value) {
        var b = ''
        if(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting')){
          b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
        }

        if(b=='' || (b && (b.rmbStk!=value || b.stkAmt!=this.$store.getters.sportMiniBet.betAmount))){
          var stkset = {
            rmbStk: value,
            stkAmt: this.$store.getters.sportMiniBet.betAmount,
          }
          var rmbstkVal = value
          $.ajax({
            method: 'post',
            url: _baseUrl + '/callCookies', 
            data: {
              action: 'rememberStk',
              stkSetting: JSON.stringify(stkset),
              acc_code: this.$store.getters.account.acccode
            },
          }).done((res) => {
            var account = this.$store.getters.account;
            account.rememberStake = rmbstkVal;
            this.$store.commit("ACCOUNT", account);
          })
        }
      },
    },
    possiblePayout() {
      var oddValue = "";
      if (this.isMulp) {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup,
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (let index = 0; index < mulpParser.length; index++) {
          const commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (let comma = 0; comma < commaList.length; comma++) {
            const betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if(this.$store.getters.account.oddsType=='am'){
              if(betOdd<0){
                betOdd=Math.abs(100/betOdd)+1;
              }else{
                betOdd= (betOdd / 100)+1;
              }
             //alert(betOdd)
              betOdd= betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      } else {
        var betOdd = parseFloat(this.$store.getters.betForm[0].odd);
        oddValue =
          (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
            ? 1
            : this.validateOddBetType(
                this.$store.getters.betForm[0].betType,
                this.$store.getters.betForm[0].odd
              );
      }
      return this.$store.getters.sportMiniBet.betAmount * oddValue;
    },
    betAmount: function() {
      var fixedAccountingNumber = accounting.toFixed(this.$store.getters.sportMiniBet.betAmount, 0);
      return this.commasAmount(fixedAccountingNumber)
    }
    // betAmount: {
    //   get() {
    //     var fixedAccountingNumber = accounting.toFixed(this.$store.getters.sportMiniBet.betAmount, 0);
    //     var res = this.$store.getters.sportMiniBet.betAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

    //     if(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting') && this.$store.getters.sportMiniBet.betAmount==0){
    //       var b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
    //       res = (b.stkAmt==0)? '' : b.stkAmt
    //       this.betAmount = res
    //       this.possiblePayout
    //       // if (this.$refs.betAmount) {
    //       //   this.$refs.betAmount[0].focus()
    //       // }
    //     }
    //     return res
    //   },
    //   set(value) {
    //     // console.log(accounting.toFixed(value, 0))
    //     var fixedAccountingNumber = accounting.toFixed(value, 0);
    //     this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);
    //     this.usualStakeAmount = fixedAccountingNumber
    //     var data = {
    //       betForm: _.cloneDeep(this.$store.getters.betForm[0]),
    //       betAmount: fixedAccountingNumber,
    //     };
    //     this.JSErr = ''
    //   },
    // },
  },
  props: {

  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isMulp: false,
      timerSeconds: 10,
      fixTimer: 10,
      timerId: null,
      pendingTimerId: null,
      isReloading: false,
      isJustRecheck: false,
      isFirstLoad: true,
      selectedLang: window._langid,
      // css: "",
      // pendingFlag: false,
      // jsError: { error: false },
      wagerId: null,
      pendingWager: {
        data: null,
        status: false,
      },
      isMulpDayExceed: false,
      totalStake: 0,
      totalBet: 0,
      langList: window.lang,
      isMulp: false,
      rememberStakeVal: false,
      mulpJsErr: {
        'error': false,
        'msg': ''
      }
    };
  },
  watch: {
    betForm: {
      handler: function(val, oldVal) {
        var vue = this
        if (this.selectedBettype.betTypId == "5" || this.$store.getters.isBetParlay) {
          this.isMulp = true;
          if(val && val.length>0){
            vue.$store.commit('BETFORM_HDPCHG',false)
            vue.$store.commit('BETFORM_ODDCHG',false)
            _.forEach(val, function(arr, key) {
              if(arr.oddChg){
                vue.$store.commit('BETFORM_ODDCHG',true)
                return
              } else if(arr.hdpChg){
                vue.$store.commit('BETFORM_HDPCHG',true)
                return
              }
            })
          }
        } else {
          this.isMulp = false;
        }
      
      },
      deep: true,
      immediate: true,
    },
    betAmount: {
      handler(value, oldVal) {

        if(this.selectedBettype.betTypId == "5" && this.$store.getters.betting.selectedBetAllup!=null){
          var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x')
          if(this.betAmount && this.$store.getters.sportMiniBet.betAmount>0){
            this.totalStake = this.$store.getters.sportMiniBet.betAmount * totalBetSlip[1];
            //this.commasAmount(
          }else{
            this.totalStake = 0;
          }
          
          this.totalBet = totalBetSlip[1];
        }

      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    clearInvalidBetCombo(){
      this.$store.commit('BETCOMBO_MESSAGE', {isClearErr: true})
      this.$store.dispatch("removeMatch", {
        data: {clearType: '1'}, //remove betcombo event with error
        callback: (() => {
          if (this.betForm.length <= 0) {
            this.cancelBetForm()
            return;
          }
          this.$store.dispatch("getBettingInfo", {
            callback: ((res) => {
              this.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: this.$store.getters.betForm,
              });
              this.refreshTimer();
              this.isReloading = false;
            }).bind(this),
          });
        }).bind(this),
      });
    },
    minComboCaption(){ 
        return this.betLang["BETTING.LBL_MIN_COMBO"].replace('{minCombo}',this.betting.minMax.minCombo);
    },
    getSubmitStyle(){
      var s = ''
      if(this.betFormOddChange || this.betFormHdpChange){
        s = 'bet-accpet'
      }else if(this.betting.error || this.betting.betcomboerror){ //this.betComboErr
        s = 'bet-submit2'
      }else if(!this.betting.success && !this.betFormOddChange && !this.betFormHdpChange){
        s = 'bet-submit'
      }
      return s
    },
    closeBetForm(){
      // if(this.$store.getters.sportMiniBet.toggle){
        this.$store.commit('SPORT_MINIBET_TOGGLE', false)
      // } else{
        this.$store.commit("OPEN_BETFORM", false)
      // }

      this.$store.commit('ODD_SELECTED', false);
      this.$store.commit("SHOW_BETFORM_MENU", false);
      this.$store.commit('SELECTED_TAB', 'betTab');
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit('BETTING_MESSAGE', { isPending: false });
      this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });
      this.$store.commit("BETCOMBO_AMOUNT", { resetBetComboAmount: true });
      this.$store.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
      this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
      // if(this.$store.getters.selectedBettype.betTypId=='5'){
        // $('div.c-bet-item.yb-family-odds').removeClass('active');
      // }
      $('div.c-bet-item').removeClass('active');
    },
    retainSelection(){
      if(!this.$store.getters.isBetCombo){
        this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
        this.$store.commit('BETTING_MESSAGE', { isError: false });
        this.$store.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
      }else{
        var arr = { clear: true }
        let VUE = this
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });

        EventBus.$emit('clearAllBetComboAmount');
        // this.clearInvalidBetCombo()
        //Remove Event Pause/Close from bet form
        // var betFormArr = _.cloneDeep(VUE.$store.getters.betForm)
        // $.each(betFormArr, function(idx, dataArr){
        //   if(!_.isUndefined(dataArr.error)){
            // document.getElementById(dataArr.uniqueId).parentElement.classList.remove('active')
            // VUE.$store.dispatch("removeMatch", {
            //   data: {clearType: '1'}, //'3', index: idx
          //   });
          // }
        // });

        this.$store.dispatch("removeMatch", {
          data: {clearType: '1'}, //remove betcombo event with error
          callback: (() => {
            if (this.betForm.length <= 0) {
              this.cancelBetForm()
              return;
            }
          }).bind(this),
        });
      }
      this.$store.commit('ODD_SELECTED', true)
      this.$store.commit('CLEAR_BET_SUCCESS')
      EventBus.$emit('stopBettingTimer');
      this.$store.commit('BETTING_MESSAGE', { isPending: false });

      this.$store.dispatch("getBettingInfo", {
        isRetainSel: true,
        callback: ((res) => {
          this.$store.commit("SPORT_MAPPING_BETTING", {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: this.$store.getters.betForm,
          });
          this.refreshTimer();
          this.isReloading = false;
        }).bind(this),
      });
    },
    getStyleTop(){
      var screenHeight = $(window).height();
      var topY;
      if(this.isUsingPhone() === 0){
        var scrFooter = document.getElementById('scrollFooter');
        if(this.$store.getters.isBetCombo ){  
          scrFooter.style.position = 'absolute'
          scrFooter.style.bottom = 0
          scrFooter.style.top = null
        } else{
          this.$nextTick(()=> {
            if(this.selectedBettype.betTypId == "5"){
              if (this.$store.getters.betForm.length > 2) {
                topY = $('#normalScroll').height();
              } else if (this.$store.getters.betForm.length == 1) {
                topY = $('#scrollHeaderX').height() + $('#normal-middle-content').height();
              } else if (this.$store.getters.betForm.length == 2) {
                //to avoid mispositioning if screenHeight < 764 when bet 2 match in parlay
                topY = (screenHeight <= 765) ? $('#mulpBetArea').height() : $('#scrollHeaderX').height() + $('#normal-middle-content').height();
              }
            } else {         
              var topY;
              if (screenHeight <= 765) {
                //$('#normalScroll').height() - 10 is to eliminate a 10px gap
                topY = (document.querySelector('.bet-confirm-message')) ? $('#normalScroll').height() - 10 : $('#normalScroll').height();
              } else {
                topY = $('#normal-middle-content').height() + $('#scrollHeaderX').height();
              }
            }
            document.getElementById('scrollFooter').style.top = topY+'px'
          });
        }
      }
      $("#leftBarNormalScroll").getNiceScroll().resize();
    },
    getDecimalDisplay(value) {
        if(this.$store.getters.account.oddsType=='am'){
          return parseFloat(value).toFixed(0);
        }
        return parseFloat(value).toFixed(2);
    },
    convertDate(val) {
      return new moment(val).format("MM-DD");
    },
    allupBetting(allup,betLang,selectedLang){
      var str="";
      if(mulpSetting[allup]){
        var ccBr=0;
        $.each(mulpSetting[allup],function(listup,cbet){
            var ssAdd="";
            if(selectedLang==1 && parseInt(cbet)>1){
              ssAdd="s";
            }
            if(betLang["BETTING.LBL_PARLAY_"+listup]){
              if(ccBr!=0) str+= "<br>";
              str+= " > "+betLang["BETTING.LBL_PARLAY_"+listup] +" ("+cbet+" "+betLang["BETTING.LBL_PARLAY_BET"] +ssAdd+")";
              ccBr=1;
            }
        });
      }
      return str;
    },
    onClickStartTimer() {
      if (!this.isJustRecheck) {
        this.isJustRecheck = false;
        this.timerSeconds = this.fixTimer;
        this.$store.dispatch("getBettingInfo", {
          token: token.arr_5,
          callback: ((res) => {
            this.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: this.$store.getters.betForm,
            });
            this.refreshTimer();
            this.isReloading = false;
          }).bind(this),
        });
      }
    },
    clearTimer() {
      clearInterval(this.timerId);
      clearInterval(this.pendingTimerId);
      this.timerId = null;
      this.pendingTimerId = null;
      this.timerSeconds = this.fixTimer;
    },
    refreshTimer() {
      this.timerSeconds = this.fixTimer;
    },
    startTimer() {
      if (this.timerId == null) {
        this.timerId = setInterval(
          (() => {
            if (this.timerSeconds - 1 < 0) {
              // this.timerSeconds = this.fixTimer;
              if (this.oddSelected && !this.isFirstLoad) {
                this.isReloading = true;
                this.$store.dispatch("getBettingInfo", {
                  
                  token: token.arr_1,
                  callback: ((res) => {
                    this.$store.commit("SPORT_MAPPING_BETTING", {
                      newBettingList: res.SYSTEM_DATA.betting,
                      oldBettingList: this.$store.getters.betForm,
                    });
                    // this.refreshTimer();
                    this.isReloading = false;
                  }).bind(this),
                });
              }
              this.isFirstLoad = false;
            } else {
              if (!this.isReloading) {
                this.timerSeconds -= 1;
              }
            }
          }).bind(this),
          1000
        );
      }
      return this.timerSeconds;
    },
    classNegative(odd) {
      return odd < 0 ? true : false;
    },
    cancelMiniBet() {
      this.$store.commit("SPORT_MINIBET_TOGGLE", false);
    },
    printBetForm() {
      window.print();
    },
    cancelBetForm() {
      if(this.betFormOddChange || this.betFormHdpChange || this.$store.getters.allowErrBetAgain){
        this.$store.commit('BETFORM_HDPCHG', false)
        this.$store.commit('BETFORM_ODDCHG', false)
        this.$store.commit('ALLOW_ERR_BET_AGAIN', false)
      }
      if(this.$store.getters.sportMiniBet.toggle){
        this.cancelMiniBet();
      }
      $('div.c-bet-item.active').removeClass('active');
      $('div.c-bet-item.yb-family-odds').removeClass('active');
      if (this.selectedBettype.betTypId == "5") {
        this.$store.commit("PARLAY_SELECTED", null);
        // $('div.c-bet-item.yb-family-odds').removeClass('active');
      } else if (this.$store.getters.isBetCombo){
        // $('div.c-bet-item.active').removeClass('active');
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true } );
      }
      this.$store.commit("BETTING_DELAY_TIMERID", null);
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit("ODD_SELECTED", false);
      // this.$store.commit("SELECTED_BETTAB", false);
      this.$store.commit('SELECTED_TAB', 'betTab')
      this.$store.commit("OPEN_BETFORM", false)
      this.$store.commit("SHOW_BETFORM_MENU", false);
      this.$store.commit("BETTING_MESSAGE", {
        isError: false,
      });
      this.$store.commit("JS_ERR", '');
      this.$store.commit("BETCOMBO_AMOUNT", { resetBetComboAmount: true });
      this.$store.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
      this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
    },
    diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    // deleteMatch(eventid) {
    //   // this.isProcessBet=true;
    //   // this.showProcessBet()
    //   if(!this.isProcessBet){
    //     this.$store.dispatch("removeMatch", {
    //       eveid: eventid,
    //       callback: (() => {
    //         this.$store.commit("PARLAY_SELECTED", {
    //           remove: true,
    //           eveid: eventid,
    //         });
    //         if (this.betForm.length <= 0) {
    //           return;
    //         }
    //         this.$store.dispatch("getBettingInfo", {
    //           callback: ((res) => {
    //             this.$store.commit("SPORT_MAPPING_BETTING", {
    //               newBettingList: res.SYSTEM_DATA.betting,
    //               oldBettingList: this.$store.getters.betForm,
    //             });
    //             this.refreshTimer();
    //             this.isReloading = false;
    //           }).bind(this),
    //         });
    //       }).bind(this),
    //     });
    //   }
    // },
    confirmBetForm(event) {
      let vue = this
      let errArr = []
      this.$store.commit('PROMO_BET_INDEX', [])
      this.$store.commit('PROMO_SHOW_JOIN_SUCCESS', false)
      this.$store.commit('PROMO_BET_WITHOUT_JOIN', false)
      this.$store.commit('SHOW_BETFORM_MENU', false)

      // if miniNormal==0 but mini toggle true, cathectic-shade affected when confirm bet, so mini toggle need to set to false
      if(!this.$store.getters.miniNormal && this.$store.getters.sportMiniBet.toggle){
        this.$store.commit('SPORT_MINIBET_TOGGLE', false)
      }
      if(!this.$store.getters.miniNormal) {
        $('#normalScroll').scrollTop(0)
      }

      if(!this.$store.getters.isBetCombo && !this.isMulp){
        let inputAmt = $('.bet-input').val()
        if(inputAmt != ''){
          let modAmt = inputAmt.replace(',','')
          if(modAmt != this.$store.getters.sportMiniBet.betAmount){
            var minMaxValidation = this.jsMinMaxValidation(
              modAmt,
              this.isMulp
            );
          }else{
            var minMaxValidation = this.jsMinMaxValidation(
              this.$store.getters.sportMiniBet.betAmount,
              this.isMulp
            );
          }
          // check if got promotion & is not MULP & user not yet joined promotion & the bet is valid for promotion
          if(this.$store.getters.promotionFlag && !this.isMulp && !this.$store.getters.promotionBetStatus && this.isSportValidPromo(this.$store.getters.betForm[0].eventObj, this.$store.getters.betForm[0].betType)){
            // check if amount meet promotion min bet requirement
            if(parseFloat(this.$store.getters.sportMiniBet.betAmount) < parseFloat(this.$store.getters.promotionDetails.min_bet)){
              this.$store.commit('PROMO_BET_WITHOUT_JOIN', true)
            } else {
              var promoBetIndex = [0];
              this.$store.commit('PROMO_BET_INDEX', promoBetIndex)
            }
          }
        }else{
          var minMaxValidation = this.jsMinMaxValidation(
            this.$store.getters.sportMiniBet.betAmount,
            this.isMulp
          );
        }
      } else if(this.isMulp) {
        // bet Mulp
        var betMulpArr = this.$store.getters.betMulpAmount
        var minMaxValidation = {}
        var ttlAmt = 0
        var betMulpArrFiltered = []
        //Check each bet, betamount limit
        $.each(betMulpArr, function(index, data){
          // var allUp = $('.bet-input')[index].id
          var allUp = data.allUp
          var amt = (data.value=='') ? 0 : data.value.replaceAll(",", "")
          var stk = (data.stake=='') ? 0 : data.stake.replaceAll(",", "")
          var pp = (data.possiblePayout=='') ? 0 : data.possiblePayout.replaceAll(",", "")
          ttlAmt += parseInt(stk)
          if(parseInt(amt)!=0){
            betMulpArrFiltered.push({
              'allUpKey':allUp,
              'amount':amt,
              'stake':stk,
              'possiblePayout':pp
            })
            var validation = vue.jsMinMaxValidation(amt, vue.isMulp, allUp);
            errArr[index] = { error: false }
            if(validation.error){
              minMaxValidation = validation
              errArr[index] = validation
            }
          }
        });
        this.$store.commit('BETMULP_AMOUNT_FILTERED', betMulpArrFiltered)
        // check total
        var minMaxValidationSUM = vue.jsMinMaxValidation(
          ttlAmt,
          vue.isMulp
        );
        if(minMaxValidationSUM.error){

          if(minMaxValidation.error){
            var a = ''
            $.each(betMulpArr, function(idx, val){
              if(errArr[idx] && errArr[idx].error){
                if(errArr[idx].errorId == 1){
                  a = Math.round(vue.account.currCL);
                }else if(errArr[idx].errorId == 2){
                  a = Math.round(vue.betting.minMax.min);
                }else if(errArr[idx].errorId == 3){
                  a = Math.round(val.maxPay);
                }
                var arr = { index: idx, allUp: val.allUp, amount: a }
                EventBus.$emit('setBetMulpAmount', arr);
              }
            });
          }
          
          this.mulpJsErr = {
            'error': minMaxValidationSUM.error,
            'msg': minMaxValidationSUM.msg
          }
          setTimeout(function() {
            vue.mulpJsErr = {
              'error': false,
              'msg': ''
            }
          }, 5000);
          return
        }
      } else {
        // bet Combo
        let betAmountArr = this.$store.getters.betComboAmount
        var amt = ''
        var minMaxValidation = {}
        var ttlAmt = 0

        if((this.betFormOddChange || this.betFormHdpChange || this.$store.getters.allowErrBetAgain) && this.$store.getters.wgHdpOddNoChgIndex.length>0){
          // remove all those bets that do not have error hdp change / error odd change
          var wgHdpOddNoChgIndex_temp = this.$store.getters.wgHdpOddNoChgIndex.sort().reverse()
          $.each(wgHdpOddNoChgIndex_temp, function(id, data){
            vue.$store.commit('BETCOMBO_AMOUNT', {spliceIndex:true,index:data})
            vue.$store.commit('REMOVE_MATCH', data)
          });
          betAmountArr = this.$store.getters.betComboAmount
          wgHdpOddNoChgIndex_temp = []
          this.$store.commit('SET_MATCH_INDEX_NO_ERR', wgHdpOddNoChgIndex_temp)
        }
        
        //Check each bet, betamount limit
        $.each(betAmountArr, function(id, data){
          amt = (data.value=='') ? 0 : data.value.replace(",", "")
          ttlAmt += parseInt(amt)
          var validation = vue.jsMinMaxValidation(amt, vue.isMulp);
          errArr[id] = { error: false }
          if(validation.error){
            minMaxValidation = validation
            errArr[id] = validation
          }
        });

        var minMaxValidationSUM = vue.jsMinMaxValidation(
          ttlAmt,
          vue.isMulp
        );
        if(minMaxValidationSUM.error){
          vue.$store.commit('JS_ERR', minMaxValidationSUM)
          setTimeout(function() {
            vue.$store.commit('JS_ERR', '')
          }, 5000);
          return
        }

        // check if got promotion & is not MULP & user not yet joined promotion
        if(this.$store.getters.promotionFlag && !this.isMulp && !this.$store.getters.promotionBetStatus){
          var promoBetIndex = []
          // check if each bet is valid for promotion and meets min bet req
          $.each(betAmountArr, function(id, data){
            amt = (data.value=='') ? 0 : data.value.replace(",", "")
              if(vue.$store.getters.betForm[id] != undefined && vue.isSportValidPromo(vue.$store.getters.betForm[id].eventObj, vue.$store.getters.betForm[id].betType)){
                if(parseFloat(amt) >= parseFloat(vue.$store.getters.promotionDetails.min_bet)){
                  promoBetIndex.push(id) // get all the bet index that valid to join promotion
                } 
              } 
          });
          if(promoBetIndex.length > 0){
            this.$store.commit('PROMO_BET_INDEX', promoBetIndex)
          } else {
            this.$store.commit('PROMO_BET_WITHOUT_JOIN', true)
          }
        }
      }
      
      if (!minMaxValidation.error) {
        this.$store.commit('PROCESS_BET', true)
        this.$store.dispatch("confirmBet", {
          callback: ((res) => {
            if(this.$store.getters.isBetCombo){
              this.betFormHeight()
            }
            this.$store.commit('PROCESS_BET', false)
            this.startTimer();
          }).bind(this),
        });
        this.$store.commit('PLACED_BET', true)

      } else {
        if(!this.$store.getters.isBetCombo && !this.isMulp){
          this.$store.commit('JS_ERR', minMaxValidation)

          if(minMaxValidation.errorId == 1){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.account.currCL);
          }else if(minMaxValidation.errorId == 2){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.min);
          }else if(minMaxValidation.errorId == 3){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.max);
          }
        } else { //bet combo or mulp
          var betAmountArr = this.$store.getters.betComboAmount
          if(vue.isMulp){
            betAmountArr = this.$store.getters.betMulpAmount
          }
          var a = ''
          $.each(betAmountArr, function(idx, val){
            if(errArr[idx] && errArr[idx].error){
              if(errArr[idx].errorId == 1){
                a = Math.round(vue.account.currCL);
              }else if(errArr[idx].errorId == 2){
                a = Math.round(vue.betting.minMax.min);
              }else if(errArr[idx].errorId == 3){
                a = Math.round(vue.betting.minMax.max);
                if(this.isMulp){
                  a = Math.round(val.maxPay);
                }
              }
              if(vue.isMulp){
                var arr = { index: idx, allUp: val.allUp, amount: a }
                EventBus.$emit('setBetMulpAmount', arr);
              } else {
                var arr = { index: idx, amount: a, clear: false }
                vue.$store.commit("BETCOMBO_AMOUNT", arr);
              }
            }
          });
          if(this.isMulp){
            this.mulpJsErr = {
              'error': minMaxValidation.error,
              'msg': minMaxValidation.msg
            }
          } else {
            this.$store.commit('BETCOMBO_JS_ERR', errArr)
          }
        }

        this.$nextTick(() => {
          if(this.selectedBettype.betTypId == "5"){
            $('.bet-input')[this.selectedMulpBetBoxId].focus();
          }else if(this.$store.getters.isBetCombo){
            $('.bet-input').focus();
          }else{
            $('.bet-input')[0].focus();
          }
        });

        setTimeout(function() {
          vue.$store.commit('JS_ERR', '')
          if(vue.$store.getters.isBetCombo){
            vue.$store.commit('BETCOMBO_JS_ERR', {})
          }
          vue.mulpJsErr = {
            'error': false,
            'msg': ''
          }
        }, 5000);
      }

    },
    checkPendingWager(wagerId) {
      if (this.pendingTimerId == null) {
        // this.pendingTimerId = setInterval(
        //   (() => {
            if (this.pendingFlag) {
              this.$store.dispatch("getPendingWager", {
                wagerIds: [wagerId],
                callback: (res) => {
                  if (res) {
                    if (res.wagerList.data[0]["wgStatus"] != "1") {
                      // this.pendingFlag = false;
                      this.$store.commit('PENDING_FLAG', false)
                      if (parseInt(res.wagerList.data[0]["wgStatus"]) < 0) {
                        this.pendingWager.data = res.wagerList.data[0];
                      }
                    }
                  }
                },
              });
            }
          // }).bind(this),
          // 5000
        // );
      }
    },
    showAutoInfo() {
      if (this.$store.getters.account.oneWallet == "1") {
        if (
          this.$store.getters.account.oddsType == "my" ||
          this.$store.getters.account.oddsType == "in" || 
          this.$store.getters.account.oddsType == "am"
        ) {
          this.autoAccBetterOdd = false;
          return false;
        }
      }
      return true;
    },
    // clearInput() {
    //   $('#betSlipStake').val("")
    //   this.$store.commit("SPORT_MINIBET_BETAMOUNT", 0);
    //   this.possiblePayout
    // },
    showProcessBet() {
      if(!this.isProcessBet){
        var minMaxValidation = this.jsMinMaxValidation(
          this.$store.getters.sportMiniBet.betAmount,
          // this.$store.getters.betAmount,
          this.isMulp
        );
        if(minMaxValidation.error){
          // this.jsError = minMaxValidation;
          this.$store.commit('JS_ERR', minMaxValidation)
          //based on error id, set betamount
          // if(minMaxValidation.errorId==1){
          //    this.$store.getters.sportMiniBet.betAmount=Math.round(this.account.currCL);
          // }else if(minMaxValidation.errorId==2){
          //     this.$store.getters.sportMiniBet.betAmount=Math.round(this.betting.minMax.min);
          // }else if(minMaxValidation.errorId==3){
          //     this.$store.getters.sportMiniBet.betAmount=Math.round(this.betting.minMax.max);
          // }
          var vue = this
          setTimeout(function() {
              vue.$store.commit('JS_ERR', '')
          }, 5000);
        }else{
          this.$store.commit('JS_ERR', '')
          $('#checkOrder').removeAttr('checked')
          this.checkOrder()
          if(this.betting.sErr){
            this.betting.sErr='';
          }
          this.$store.commit('PROCESS_BET', true)
          $('#submitBet').focus();
        }
      }else if(this.isProcessBet){
        $('#checkOrder').attr('checked', 'checked')
        this.checkOrder()
        this.$store.commit('PROCESS_BET', false)

      }
    },
    checkError(errMsg) {
      if(errMsg){
        this.$store.commit('PLACED_BET', false)
        this.$store.commit('PROCESS_BET', false)
        return errMsg
      }
    },
    h1x2Header(hdp, team){
      if(team == 'a'){
        if(hdp > 0){
          return ' +' + parseInt(hdp)
        }else if(hdp < 0) {
          return parseInt(hdp)
        }
      }else if(team == 'b'){
        var nhdp = parseInt(hdp) * -1
        var ahdp = ''

        if(nhdp > 0){
          ahdp = '+' + nhdp
        }else if(nhdp < 0){
          ahdp = nhdp
        }

        return ahdp
      }else if(team == 'x'){
        if(hdp > 0){
          return this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' +' + parseInt(hdp) 
        }else if(hdp < 0){
          var nhdp = parseInt(hdp) * -1
          var ahdp = ''

          if(nhdp > 0){
            ahdp = '+' + nhdp
          }else if(nhdp < 0){
            ahdp = nhdp
          }
          return this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + ahdp
        }
      }
    },
    modifyTitle(odds){
      var title = this.sportAllBetLang["ALL_BET.LBL_WIN_BY_26MORE"]
      if(odds == 'h_26_x' || odds == 'a_26_x'){
        return title.replace('26','26+')
      }
    },
    isSportValidPromo(eventObj, bt){ // check if the bet is valid for promotion
      var result = false;
      this.$store.dispatch("isSportValidPromo", {
        eventObj:eventObj,
        bt:bt,
        callback: ((res) => {
          result = res
        }).bind(this),
      });
      return result
    },
    getBetConfirmClass(){
      if(this.betting.success || this.betting.betcombosuccess){
        return 'bet-success-order'
      } else if (this.betting.pending){
        return 'bet-pending-order'
      } else {
        return 'bet-fail-order'
      }
    },
  },
  beforeMount() {
    
  },
  mounted() {
    // EventBus.$on("stopBettingTimer", (res) => {
    //   this.clearTimer();
    //   if (res) {
    //     // this.pendingFlag = false;
    //     this.$store.commit('PENDING_FLAG', false)
    //     _.forEach(
    //       res.SYSTEM_DATA.betting,
    //       function (value) {
    //         if (
    //           value.wgStatus == "1" &&
    //           this.rbettype.indexOf(value.betType) != -1 &&
    //           value.sprtid == "1"
    //         ) {
    //           // this.pendingFlag = true;
    //           this.$store.commit('PENDING_FLAG', true)
    //         }
    //       }.bind(this)
    //     );
    //     this.checkPendingWager(res.SYSTEM_DATA.WagerID);
    //   }
    // });

    // EventBus.$on("processOdChange", (res) => {
    //   this.betFormOddChange = res
    // });
    // EventBus.$on("processHdpChange", (res) => {
    //   this.betFormHdpChange = res
    // });
    
    EventBus.$on("betSlipCss", (res) => {
      this.getStyleTop()
    });
    EventBus.$on("initBettingTimer", (res) => {
      this.clearTimer();
      this.startTimer();
      this.pendingWager.data = null;
      // this.pendingFlag = false;
      this.$store.commit('PENDING_FLAG', false)
    });
    EventBus.$on("cancelBetForm", () => {
      this.cancelBetForm();
    });
    if (this.oddSelected) {
      EventBus.$emit("initBettingTimer");
    }
    EventBus.$on("processBet", () =>{
      this.showProcessBet()
      if(this.isProcessBet){
        // $('#checkOrder').attr('checked', 'checked')
        this.checkOrder()
      }else{
        // $('#checkOrder').removeAttr('checked')
        this.checkOrder()
      }
    })
    if(!this.$store.getters.sportMiniBet.toggle){
      this.getStyleTop()
    }
  },
  beforeDestroy() {
    EventBus.$off("stopBettingTimer");
    EventBus.$off("betSlipCss");
    EventBus.$off("initBettingTimer");
    EventBus.$off("cancelBetForm");
    EventBus.$off("processBet");
    // EventBus.$off("processOdChange");
    // EventBus.$off("processHdpChange");
    this.clearTimer();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/base/global";
// @import "~@/styles/home/contentsLeft/bettingForm";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/bettingFormFooter.vue